// JSX component descriptors used by mdxeditor's jsxPlugin. Each descriptor
// tells mdxeditor how to recognize a custom MDX component, what props it
// accepts, and how to render an in-editor representation.
//
// The renderer for each is intentionally minimal — a placeholder block with
// the component name and editable children — because the source of truth is
// still the MDX text. The published site renders the real components.

import {
  type JsxComponentDescriptor,
  GenericJsxEditor,
} from '@mdxeditor/editor';

export const jsxComponentDescriptors: JsxComponentDescriptor[] = [
  {
    name: 'Callout',
    kind: 'flow',
    props: [{ name: 'type', type: 'string' }],
    hasChildren: true,
    Editor: GenericJsxEditor,
  },
  {
    name: 'ExpandableImage',
    kind: 'flow',
    props: [
      { name: 'src', type: 'string' },
      { name: 'alt', type: 'string' },
      { name: 'width', type: 'number' },
      { name: 'height', type: 'number' },
    ],
    hasChildren: false,
    Editor: GenericJsxEditor,
  },
  {
    name: 'VideoEmbed',
    kind: 'flow',
    props: [
      { name: 'url', type: 'string' },
    ],
    hasChildren: false,
    Editor: GenericJsxEditor,
  },
  {
    name: 'Accordion',
    kind: 'flow',
    props: [],
    hasChildren: true,
    Editor: GenericJsxEditor,
  },
  {
    name: 'AccordionItem',
    kind: 'flow',
    props: [{ name: 'title', type: 'string' }],
    hasChildren: true,
    Editor: GenericJsxEditor,
  },
];
